import { BaseHTMLAttributes } from '@mi-front/core';
import { Box, CircularProgress, IconButton, IconButtonProps, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { palette } from '@ui/styles';
import classNames from 'classnames';
import omit from 'lodash/omit';

const StyledMenu = styled('div')(({ theme }) => ({
  display: 'flex',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '1.5rem',
  padding: '0 0.5rem',
  background: theme.palette.background.paper,
  opacity: 1,
  transition: 'opacity 0.2s',
  '& button': {
    color: theme.palette.text.primary,
    border: 'none',
    marginLeft: 0,
    '&:active:enabled': {
      boxShadow: 'none',
    },
    '&:hover': {
      color: palette.aqua, // $color-Aqua
    },
  },
}));

export interface MenuAction {
  readonly icon: React.ReactNode;
  readonly onClick: () => void;
  readonly tooltip: React.ReactNode;
  readonly enabled?: boolean;
  readonly loading?: boolean;
  readonly btnProps?: Partial<Omit<IconButtonProps, 'onClick' | 'children'>> & {
    'data-testid'?: string;
  };
}

interface Props extends BaseHTMLAttributes {
  readonly actions: readonly MenuAction[];
}

export function Menu(p: Props) {
  return (
    <StyledMenu className={classNames('el-menu', p.className)}>
      {p.actions.map(
        ({ icon, onClick, tooltip, enabled, loading, btnProps }, index) =>
          enabled !== false && (
            <Tooltip key={index} placement="top" title={tooltip}>
              <Box component="span" sx={{ display: 'inline-flex' }}>
                <IconButton
                  color="inherit"
                  disabled={loading || btnProps?.disabled}
                  onClick={onClick}
                  {...omit(btnProps || {}, 'onClick', 'children', 'disabled')}
                >
                  {loading ? (
                    <CircularProgress size={20} color="inherit" sx={{ color: 'action.disabled' }} />
                  ) : (
                    icon
                  )}
                </IconButton>
              </Box>
            </Tooltip>
          ),
      )}
    </StyledMenu>
  );
}
